import * as React from "react";
const SvgCaretIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path d="M6 10.501L9 7.50098L12 10.501" strokeLinecap="square" /></svg>;
export default SvgCaretIcon;